import { render, staticRenderFns } from "./LocationMemberTodo.vue?vue&type=template&id=6a8be80d"
import script from "./LocationMemberTodo.vue?vue&type=script&lang=js"
export * from "./LocationMemberTodo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports